import {register} from '../vendor/theme-scripts/theme-sections';
import setBadgePosition from '../features/badge-position';
import {makeGridSwatches} from '../features/swatch';
import {Quickview} from '../features/quickview';
import debounce from '../util/debounce';

const sections = {};

const selectors = {
  section: '[data-section-type="related-products"]',
  product: '[data-product-block]',
  productImage: '[data-product-image]',
  sectionId: 'data-section-id',
  productId: 'data-product-id',
  limit: 'data-limit',
};

class RelatedProducts {
  constructor(section) {
    this.container = section.container;
    this.resizeEvent = null;

    this.init();
  }

  init() {
    const self = this;
    const relatedSection = this.container;
    const sectionId = relatedSection.getAttribute(selectors.sectionId);
    const productId = relatedSection.getAttribute(selectors.productId);
    const limit = relatedSection.getAttribute(selectors.limit);
    const requestUrl = `${theme.routes.product_recommendations_url}?section_id=${sectionId}&limit=${limit}&product_id=${productId}`;

    fetch(requestUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (data) {
        const createdElement = document.createElement('div');
        createdElement.innerHTML = data;
        const inner = createdElement.querySelector(selectors.section);

        if (inner.querySelector(selectors.product)) {
          relatedSection.innerHTML = inner.innerHTML;

          makeGridSwatches(relatedSection);
          new Quickview(relatedSection);

          const images = relatedSection.querySelectorAll(selectors.productImage);
          self.resizeEvent = debounce(() => setBadgePosition(images), 50);

          if (theme.settings.imageBackgroundSize === 'contain' && images) {
            setBadgePosition(images);

            window.addEventListener('resize', self.resizeEvent);
          }
        }
      });
  }
  onUnload() {
    if (this.resizeEvent) {
      window.removeEventListener('resize', this.resizeEvent);
    }
  }
}

const RelatedSection = {
  onLoad() {
    sections[this.id] = new RelatedProducts(this);
  },
  onUnload(e) {
    sections[this.id].onUnload(e);
  },
};

register('related-products', RelatedSection);
